module.exports = __webpack_public_path__ + "static/media/mlp-logo.a4c55011.svg";